export default __webpack_public_path__ + "static/media/Honored Straps of the Far Horizon.7a826c5b.jpg";